import React from 'react';
import { Translate } from 'src/components/translate';
import { colors } from 'src/components/base';
import { IconCloseFilled } from '@prisjakt/ui/icon/close-filled';
import { IconCheckFilled } from '@prisjakt/ui/icon/check-filled';
import { IconQuestionFilled } from '@prisjakt/ui/icon/question-filled';
import * as S from './styles';

interface ColoredIconProps {
  color: string;
}

const ColoredIcon: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ColoredIconProps>
>> = ({ children, color }) => (
  <S.ColoredIconWrapper color={color}>{children}</S.ColoredIconWrapper>
);

export const Yes = () => (
  <ColoredIcon color={colors.lightTheme.positive500}>
    <IconCheckFilled size={18} color="positive500" />
    <Translate domain="product">property.boolean-yes</Translate>
  </ColoredIcon>
);

export const No = () => (
  <ColoredIcon color={colors.lightTheme.negative700}>
    <IconCloseFilled size={18} color="negative700" />
    <Translate domain="product">property.boolean-no</Translate>
  </ColoredIcon>
);

export const Unknown = () => (
  <ColoredIcon color={colors.lightTheme.base400}>
    <IconQuestionFilled size={18} color="base400" />
  </ColoredIcon>
);

export default ColoredIcon;
